import { render, staticRenderFns } from "./TabelaNota.vue?vue&type=template&id=7ebbdd50&"
import script from "./TabelaNota.vue?vue&type=script&lang=js&"
export * from "./TabelaNota.vue?vue&type=script&lang=js&"
import style0 from "./TabelaNota.vue?vue&type=style&index=0&id=7ebbdd50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports